import * as Yup from 'yup';

const FilterAffiliateSchema = Yup.object().shape({
  affiliate_value: Yup.string()
    .nullable()
    .when('affiliate_type', {
      is: 'affiliate_email',
      then: Yup.string().email('Insira um e-mail válido')
    })
    .when('affiliate_type', {
      is: 'affiliate_name',
      then: Yup.string().min(5, 'Insira pelo menos 5 caracteres')
    })
});

export default FilterAffiliateSchema;
